
// components
import Categories from '../../components/categories/categories.component'
import Header from '../../components/header/header.components'

const HomePage = () => {
  return (
    <>
      <Header />
      <Categories />
    </>
  )
}

export default HomePage
